import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  InputNumber,
  Select,
  message,
  Modal,
  Row,
} from "antd";
import { withNamespaces } from "react-i18next";
// import SyntaxHighlighter from "react-syntax-highlighter";
// import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import classes from "./style.css";

import {
  generateConfigData,
  generateConfigDataCSV,
  simulateConfigDataCSV,
} from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";
import { v4 as uuidv4 } from "uuid";

class PermutedBlocksForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingData: false,
      isLoading: false,
      errorMessage: null,
      stratGroupsKeys: [],
      dataType: null,
      generatedData: null,
      generatedDataSimulation: null,
      simulateModalOpen: false,
    };
  }

  componentDidMount() {
    this.initialSeed = this.randomNumber(10);
  }

  handleSubmit = () => {
    this.props.form.validateFields(async (err, values) => {
      this.setState({
        isSubmitted: true,
        requestResult: {},
        // generatedData: null,
        // generatedDataSimulation: null,
      });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const data = { ...values };
          if (values.block_sizes) {
            data.block_sizes = values.block_sizes.split(",");
            for (let i = 0; i < data.block_sizes.length; i++) {
              data.block_sizes[i] = data.block_sizes[i].trim();
            }
          }

          if (values.groups) {
            data.groups = values.groups.split(",");
            for (let i = 0; i < data.groups.length; i++) {
              data.groups[i] = data.groups[i].trim();
            }
          }

          data.stratification_factors = [];

          if (
            values.strat_groups &&
            Object.keys(values.strat_groups).length > 0
          ) {
            data.stratification_factors = Object.keys(values.strat_groups).map(
              (key) => values.strat_groups[key].name
            );
          } else {
            delete data.stratification_factors;
          }

          delete data.strat_groups;

          if (this.state.dataType === "generate") {
            const result = await generateConfigData(data);

            this.setState({
              generatedData: result.data,
            });
          }

          if (this.state.dataType === "downloadCsv") {
            const result = await generateConfigDataCSV(data);

            const blob = new Blob([result.data]);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `permuted-blocks-list.csv`;
            link.click();
          }

          if (this.state.dataType === "simulation") {
            const dataSimulate = {
              simulation_settings: {
                subject_count: data.subject_count,
                simulation_count: data.simulation_count,
                algorithm_type: data.algorithm_type,
                strata_allocation_method:
                  data.strata_allocation_method_simulation,
              },
              pb_settings: {
                list_length: data.list_length,
                block_sizes: data.block_sizes,
                add_cohort: data.add_cohort,
                seed: data.seed,
                stratification_factors: data.stratification_factors,
                strata_allocation_method: data.strata_allocation_method,
              },
            };

            if (
              !(
                values.strat_groups &&
                Object.keys(values.strat_groups).length > 0
              )
            ) {
              delete dataSimulate.pb_settings.stratification_factors;
            } else {
              console.log(values);
              Object.keys(values.strat_groups).forEach((key) => {
                const item = values.strat_groups[key].name;

                const vals = item.split(":");
                const fieldName = vals[0];

                if (!vals[1]) {
                  return;
                }

                const keys = map(vals[1].split(","), (item) => item.trim());

                if (!keys || keys.length === 0) {
                  return;
                }

                return map(keys, (key) => {
                  dataSimulate.simulation_settings[`${fieldName}_${key}`] =
                    data[`${fieldName}_${key}`];
                });
              });
            }

            const result = await simulateConfigDataCSV(dataSimulate);

            const blob = new Blob([result.data]);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `permuted-blocks-simulate-list.csv`;
            link.click();
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
            // simulateModalOpen: false,
          });
        } catch (e) {
          console.log(e);
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: JSON.stringify(get(e, "response.data", "Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  removeStratGroup = (key) => {
    const stratGroupsKeys = [...this.state.stratGroupsKeys].filter(
      (k) => key !== k
    );

    this.setState({
      stratGroupsKeys,
    });
  };

  addStratGroup = () => {
    this.setState({
      stratGroupsKeys: [...this.state.stratGroupsKeys, uuidv4()],
    });
  };
  randomNumber = (n) => {
    let randomNumber = "";
    for (let i = 0; i < n; i++) {
      randomNumber += Math.floor(Math.random() * n);
    }
    return randomNumber;
  };

  render() {
    const {
      isLoading,
      errorMessage,
      stratGroupsKeys,
      generatedData,
      requestResult,
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;

    const strat_groups = getFieldValue("strat_groups");

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">Permuted Blocks Generator</h3>

        <Form onSubmit={this.handleSubmit}>
          <Row gutter={24}>
            <Col sm={8}>
              <Row gutter={8}>
                <Col sm={24}>
                  <Form.Item label={this.props.i18n.t("List length")}>
                    {getFieldDecorator("list_length", {
                      initialValue: 100,
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(<InputNumber placeholder="100" />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col sm={24}>
                  <Form.Item label={this.props.i18n.t("Groups (defaults to project groups unless cohorts are used)")}>
                    {getFieldDecorator("groups", {
                      rules: [
                        {
                          required: getFieldValue("add_cohort"),
                          message: this.props.i18n.t("Required"),
                        },
                      ],
                    })(
                      <Input placeholder={this.props.i18n.t("a, b, c (leave empty to use project groups)")} />
                    )}
                  </Form.Item>
                </Col>
                {getFieldValue("add_cohort") && (
                  <p>
                    <i>{this.props.i18n.t("Groups may be different for each cohort.")}</i>
                  </p>
                )}
              </Row>
              <Row gutter={8}>
                <Col sm={24}>
                  <div style={{ margin: "0 0 20px" }}>
                    {getFieldDecorator("add_cohort", {
                      initialValue: false,
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={false}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("Add cohort")}
                        </span>
                      </Checkbox>
                    )}
                  </div>
                </Col>
                {getFieldValue("add_cohort") && (
                  <p>
                    <i>
                      {this.props.i18n.t(`To add multiple cohorts to your project permuted blocks:
                      generate a permuted blocks table for each cohort with a
                      different seed and settings but keep factors the same.
                      Download each permuted blocks csv file and then unite them
                      into one, which you can upload to the project in the
                      randomization config. Upload can be made only if there are
                      no active subjects.`)}
                    </i>
                  </p>
                )}
              </Row>
              {getFieldValue("add_cohort") && (
                <Row gutter={8}>
                  <Col sm={24}>
                    <Form.Item label={this.props.i18n.t("Cohort SLUG")}>
                      {getFieldDecorator("cohort_slug", {
                        rules: [
                          {
                            required: getFieldValue("add_cohort"),
                            message: this.props.i18n.t("Required"),
                          },
                        ],
                      })(<Input placeholder="" />)}
                    </Form.Item>
                  </Col>
                  <p>
                    <i>{this.props.i18n.t("Should match cohorts defined in the project.")}</i>
                  </p>
                </Row>
              )}
              <Row gutter={8}>
                <Col sm={24}>
                  <Form.Item label={this.props.i18n.t("Block sizes (multiples of number of groups)")}>
                    {getFieldDecorator("block_sizes", {
                      initialValue: "4,6,8",
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(<Input placeholder="4,6,8" />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col sm={24}>
                  <Form.Item label={this.props.i18n.t("Seed")}>
                    {getFieldDecorator("seed", {
                      initialValue: this.initialSeed,
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(
                      <Input
                        placeholder="32123131242431"
                        addonAfter={
                          <Icon
                            onClick={() => {
                              this.props.form.setFieldsValue({
                                seed: this.randomNumber(10),
                              });
                            }}
                            type="redo"
                            style={{ cursor: "pointer" }}
                          />
                        }
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>



              <Row gutter={8}>
                <Col sm={24}>
                  <div className={classes.stratGroup}>
                    <h5 className="headline-default">{this.props.i18n.t("Stratification factors")}</h5>
                    {getFieldValue("add_cohort") && (
                      <p>
                        <i>
                          {this.props.i18n.t("Factors should match between cohorts. Do not add the cohort itself as a factor.")}
                        </i>
                      </p>
                    )}
                    {stratGroupsKeys.map((key, i) =>
                      key ? (
                        <div className={classes.itemGroup} key={i}>
                          <div style={{ fontSize: "16px" }}>
                            <b>#{i + 1}</b>
                            <Icon
                              style={{
                                margin: "3px 0 5px 10px",
                                color: "#f00",
                              }}
                              type="delete"
                              onClick={() => {
                                this.removeStratGroup(key);
                              }}
                            />
                          </div>
                          <Row gutter={8}>
                            <Col lg={24}>
                              <div>
                                <Form.Item label={this.props.i18n.t("Factor (Name: val1, val2)")}>
                                  {getFieldDecorator(
                                    `strat_groups[${key}].name`,
                                    {
                                      rules: [
                                        {
                                          required: true,
                                          message: this.props.i18n.t("Required"),
                                        },
                                      ],
                                    }
                                  )(
                                    <Input
                                      placeholder={this.props.i18n.t("Name: val1, val2")}
                                      allowClear
                                    />
                                  )}
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      ) : null
                    )}

                    {stratGroupsKeys.filter((item) => item).length < 20 && (
                      <p>
                        <Button
                          type="button"
                          size="small"
                          style={{ padding: "0.3rem" }}
                          onClick={this.addStratGroup}
                        >
                          Add
                        </Button>
                      </p>
                    )}
                    <hr/>
                    <br/>
                    <Col sm={24}>
                      <div style={{ margin: "0 0 30px" }}>
                        {getFieldDecorator("factor_in_site_code", {
                          valuePropName: "checked",
                        })(
                          <Checkbox disabled={false}>
                            <span style={{ fontSize: "16px" }}>
                              {this.props.i18n.t("Add site codes to factors")}
                            </span>
                          </Checkbox>
                        )}
                      </div>
                    </Col>
                    {getFieldValue("factor_in_site_code") && (
                      <div>
                      <Col sm={24}>
                        <Form.Item label={this.props.i18n.t("Explicit Site codes (leave empty to use project site codes)")}>
                          {getFieldDecorator("site_code_values", {
                            rules: [
                              {
                                required: false,
                                message: this.props.i18n.t("Required"),
                              },
                            ],
                          })(
                            <Input placeholder={this.props.i18n.t("001, 201, 300, 4 (numbers, prefixed or not prefixed by '0')")} />
                          )}
                        </Form.Item>
                      </Col>
                      {getFieldValue("add_cohort") && (
                        <p>
                          <i>{this.props.i18n.t("Site codes need to be the same for each cohort.")}</i>
                        </p>
                      )}
                      </div>
                    )}

                  </div>
                </Col>
              </Row>

              {stratGroupsKeys && stratGroupsKeys.length > 0 && (
                <Row gutter={8}>
                  <Col sm={24}>
                    <Form.Item label={this.props.i18n.t("Strata allocation method")}>
                      {getFieldDecorator("strata_allocation_method")(
                        <Select
                          placeholder={this.props.i18n.t("Select")}
                          allowClear
                        >
                          <Select.Option value="pre_assigned">
                            {this.props.i18n.t("Pre assigned")}
                          </Select.Option>
                          <Select.Option value="pre_assigned_with_rejection">
                            {this.props.i18n.t("Pre assigned with rejection")}
                          </Select.Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              )}

              {requestResult && requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}
              <br />

              <Row gutter={8}>
                {errorMessage && (
                  <Col span={24}>
                    <Alert message={errorMessage} type="error" />
                  </Col>
                )}
                <Col span={24}>
                  <Button
                    type="primary"
                    size="small"
                    htmlType="button"
                    onClick={(e) => {
                      this.props.form.validateFields(async (err) => {
                        if (!err) {
                          this.setState({ dataType: "generate" }, () => {
                            this.handleSubmit();
                          });
                        }
                      });
                    }}
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    {this.props.i18n.t("Generate data")}
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    type="primary"
                    size="small"
                    htmlType="button"
                    onClick={(e) => {
                      this.props.form.validateFields(async (err) => {
                        if (!err) {
                          this.setState({
                            dataType: "simulation",
                            simulateModalOpen: true,
                          });
                        }
                      });
                    }}
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    {this.props.i18n.t("Run a simulation")}
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    type="primary"
                    size="small"
                    htmlType="button"
                    onClick={(e) => {
                      this.props.form.validateFields(async (err) => {
                        if (!err) {
                          this.setState({ dataType: "downloadCsv" }, () => {
                            this.handleSubmit();
                          });
                        }
                      });
                    }}
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    {this.props.i18n.t("Download .csv")}
                  </Button>
                </Col>
              </Row>
            </Col>

            <Modal
              visible={this.state.simulateModalOpen}
              onCancel={() =>
                this.setState({
                  simulateModalOpen: false,
                })
              }
              footer={null}
            >
              {this.state.simulateModalOpen && (
                <Row gutter={8}>
                  <Col sm={24}>
                    <Form.Item label={this.props.i18n.t("Subject count")}>
                      {getFieldDecorator("subject_count", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<InputNumber placeholder="100" />)}
                    </Form.Item>
                  </Col>
                  <Col sm={24}>
                    <Form.Item label={this.props.i18n.t("Simulation count")}>
                      {getFieldDecorator("simulation_count", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<InputNumber placeholder="1" />)}
                    </Form.Item>
                  </Col>
                  {strat_groups && Object.keys(strat_groups).length > 0 && (
                    <div>
                      {map(Object.keys(strat_groups), (key, i) => {
                        const item = get(strat_groups[key], "name", "");
                        const vals = item.split(":");
                        const fieldName = vals[0];

                        if (!vals[1]) {
                          return;
                        }

                        const keys = map(vals[1].split(","), (item) =>
                          item.trim()
                        );

                        if (!keys || keys.length === 0) {
                          return;
                        }

                        return map(keys, (key, j) => {
                          return (
                            <Col sm={24} key={`${i}_${j}`}>
                              <Form.Item label={`${fieldName} ${key} %`}>
                                {getFieldDecorator(`${fieldName}_${key}`, {
                                  rules: [
                                    { required: true, message: this.props.i18n.t("Required") },
                                  ],
                                })(<InputNumber placeholder="%" />)}
                              </Form.Item>
                            </Col>
                          );
                        });
                      })}
                    </div>
                  )}
                  {/*<Col sm={24}>
                    <Form.Item label={this.props.i18n.t("Sex female %")}>
                      {getFieldDecorator("sex_female", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<InputNumber placeholder="50" />)}
                    </Form.Item>
                  </Col>
                  <Col sm={24}>
                    <Form.Item label={this.props.i18n.t("Sex male %")}>
                      {getFieldDecorator("sex_male", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<InputNumber placeholder="50" />)}
                    </Form.Item>
                  </Col>*/}
                  <Col sm={24}>
                    <hr></hr>
                    <Row gutter={8}>
                      <Col span={24}>
                        <h5>
                          <i>{this.props.i18n.t("DEBUG fields")}:</i>
                        </h5>

                        {stratGroupsKeys && stratGroupsKeys.length > 0 && (
                          <Form.Item label={this.props.i18n.t("Strata allocation method")}>
                            {getFieldDecorator(
                              "strata_allocation_method_simulation"
                            )(
                              <Select
                                placeholder={this.props.i18n.t("Select")}
                                allowClear
                                style={{ width: "100%" }}
                              >
                                <Select.Option value="pre_assigned">
                                  {this.props.i18n.t("Pre assigned")}
                                </Select.Option>
                                <Select.Option value="pre_assigned_with_rejection">
                                  {this.props.i18n.t("Pre assigned with rejection")}
                                </Select.Option>
                              </Select>
                            )}
                          </Form.Item>
                        )}
                        <Row>
                          <Col>
                            <Form.Item label={this.props.i18n.t("Algorithm type")}>
                              {getFieldDecorator("algorithm_type", {
                                initialValue: "permuted_blocks",
                              })(
                                <Select
                                  placeholder={this.props.i18n.t("Select")}
                                  allowClear
                                  style={{ width: "100%" }}
                                >
                                  <Select.Option value="permuted_blocks">
                                    {this.props.i18n.t("Permuted blocks")}
                                  </Select.Option>
                                  <Select.Option value="true_random">
                                    {this.props.i18n.t("True Random")} (test only)
                                  </Select.Option>
                                  <Select.Option value="biased_coin">
                                    {this.props.i18n.t("Biased Coin")} (test only)
                                  </Select.Option>
                                  <Select.Option value="mstb_algorithm">
                                    {this.props.i18n.t("MSTB Random")} (test only)
                                  </Select.Option>
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={24}>
                    {requestResult && requestResult.type && (
                      <Alert
                        message={requestResult.message}
                        type={requestResult.type}
                        className={classes.submitResult}
                      />
                    )}

                    <Row gutter={8}>
                      <Col span={24}>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={(e) => {
                            this.props.form.validateFields(async (err) => {
                              if (!err) {
                                this.setState(
                                  { dataType: "simulation" },
                                  () => {
                                    this.handleSubmit();
                                  }
                                );
                              }
                            });
                          }}
                          disabled={isLoading}
                          loading={isLoading}
                        >
                          {this.props.i18n.t("Run a simulation")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Modal>

            <Col sm={16}>
              <div className={classes.result}>
                <h4 className="headline-default">{this.props.i18n.t("Result")}</h4>

                {isLoading && <Icon type="loading" />}

                {generatedData && (
                  <div>
                    <h5 className="headline-default">{this.props.i18n.t("Info")}</h5>

                    <div className={classes.resultItem}>
                      <b>Treatment groups</b>:{" "}
                      {JSON.stringify(
                        get(generatedData, "config.treatment_groups")
                      )}
                    </div>
                    <div className={classes.resultItem}>
                      <b>Seed</b>:{" "}
                      {JSON.stringify(get(generatedData, "config.seed"))}
                    </div>
                    <div className={classes.resultItem}>
                      <b>Actual length</b>:{" "}
                      {get(generatedData, "info.actual_length")}
                    </div>
                    <div className={classes.resultItem}>
                      <b>Number of strata</b>:{" "}
                      {get(generatedData, "info.number_of_strata")}
                    </div>
                    <div className={classes.resultItem}>
                      <b>Recommended sample size</b>:{" "}
                      {get(generatedData, "info.maximum_sample_size")}
                    </div>
                    <div className={classes.resultItem}>
                      <b>Block sizes</b>:{" "}
                      {JSON.stringify(get(generatedData, "config.block_sizes"))}
                    </div>
                    <div className={classes.resultItem}>
                      <b>Stratification Factors</b>:{" "}
                      {JSON.stringify(
                        get(generatedData, "config.stratification_factors")
                      )}
                    </div>

                    <div className={classes.resultItem}>
                      {/*<SyntaxHighlighter
                        language="json"
                        style={docco}
                        wrapLongLines={true}
                      >
                        {JSON.stringify(get(generatedData, "info"))}
                      </SyntaxHighlighter>*/}

                      <code className={classes.codeTextLarge}>
                        {JSON.stringify(get(generatedData, "info"))}
                      </code>
                    </div>

                    {/*<h5 className="headline-default">Config</h5>

                    <div className={classes.resultItem}>
                      <b>Num blocks</b>:{" "}
                      {get(generatedData, "config.num_blocks")}
                    </div>

                    <div className={classes.resultItem}>
                      <b>Treatment groups</b>:{" "}
                      {JSON.stringify(
                        get(generatedData, "config.treatment_groups")
                      )}
                    </div>

                    <div className={classes.resultItem}>
                      <b>Permutation elements</b>:{" "}
                      {map(
                        get(generatedData, "config.permutation_elements", []),
                        (item, i) => {
                          return (
                            <code key={i} className={classes.codeText}>
                              {JSON.stringify(item)}
                            </code>
                          );
                        }
                      )}
                    </div>

                    <SyntaxHighlighter language="json" style={docco} wrapLongLines={true}>
                      {JSON.stringify(
                        get(generatedData, "config.permutation_elements")
                      )}
                    </SyntaxHighlighter>*/}

                    <h5 className="headline-default">CSV</h5>
                    <div className={classes.resultItem}>
                      {map(get(generatedData, "csv", []), (item, i) => {
                        return (
                          /*<SyntaxHighlighter
                            language="json"
                            style={docco}
                            wrapLongLines={true}
                          >
                            {JSON.stringify(item)}
                          </SyntaxHighlighter>*/

                          <code key={i} className={classes.codeText}>
                            {JSON.stringify(item)}
                          </code>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "PermutedBlocksForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(PermutedBlocksForm))
);



// WEBPACK FOOTER //
// ./src/containers/PermutedBlocks/PermutedBlocksForm.js